module.exports = __webpack_public_path__ + "static/media/infinite1.ed8f69e6.PNG";